import {
  titleUI,
  ssnUI,
  ssnSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validations } from '../../validations';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['your-id-title']),
    yourSocialSecurityNumber: {
      ...ssnUI(),
      'ui:validations': [validations.isSsnDuplicated],
    },
  },
  schema: {
    type: 'object',
    required: ['yourSocialSecurityNumber'],
    properties: {
      yourSocialSecurityNumber: ssnSchema,
    },
  },
};
